import React from "react";
import Async from "react-select/async";
import { getCustomStyles } from "./field-themes";

export default function FieldDropdownSelect({item, loadOptions, options, defaultOptions, onChange}) {
    if (!item.props) {
        item.props = {}
    }

    return (
        <Async
            key={item.props.key}
            autoFocus={item.props.autoFocus}
            ref={item.props.innerRef}
            styles={getCustomStyles()}
            className={"select-css-search p-0 form-control " + (!!item.props.addClass ? item.props.addClass : '')}
            isDisabled={!!item.disabled}
            onChange={(selectedOption) => {
                onChange(item.name, selectedOption);
            }}
            name={item.name}
            value={item.value}
            options={options}
            loadOptions={loadOptions}
            defaultOptions={defaultOptions}
            isClearable={!!item.props.isClearable}
            isMulti={item.props.multi}
            placeholder={item.props.placeholder}
            menuPlacement={item.props.menuPlacement}
            menuPortalTarget={item.props.hasPortal ? document.body : null}
            menuPosition={item.props.menuPosition}
        />
    )
}
